/* Bevel facets: dropdown panels, buttons, the header bar and the footer. Added by
   Claude. The mobile drawer and the mobile footer are handled in CSS instead - see
   mr-drawer.css and mr-footer-mobile.css.

   WHAT IT DRAWS. Two nested rectangles stepped in from the frame, and a pair of
   diagonals at the top-right and bottom-right corners closing a triangular facet
   against the frame's own chamfer.

   WHY PANELS ARE DRAWN BEFORE THEY OPEN - the delay, and how it was finally fixed.
   A hidden panel has no size, so it cannot be measured, so the facet could not be
   drawn until after the menu appeared. Every earlier attempt tried to REACT faster:
   an observer on the panel, transitionend, pointer events, a stability check. All of
   them still ran after the panel opened, so a delay was inherent - the menu arrived,
   then the facet caught up.
   prime() removes the race instead of trying to win it. At load, each panel is briefly
   forced measurable - off-screen, invisible, not displayed to the user - measured,
   drawn into, and restored to exactly the inline styles it had. The SVG stays inside
   the panel. By the time anyone hovers, the facet is already there.

   The restore is the part to be careful with: the panel's own inline style is captured
   as a string and written back verbatim, so nothing the theme set is lost. It happens
   in the same frame, before the browser paints, so nothing flashes.

   The reactive paths are still here, but only as a safety net for panels that change
   size later - a menu item added by an app, a font swapping in.

   WHERE IT RUNS.
     - PANEL   desktop dropdowns.
     - BUTTON  every width, including all three AP Bamboo guide buttons - the homepage
               one's class is a random hash, hence the wildcard.
     - BAR     every width. Desktop: fades out at the last top-level nav item. Mobile:
               just past the crest.
     - FOOTER  desktop only. Below 768px mr-footer-mobile.css draws a mirrored version
               and this one stands down, so the two never both paint - they did once,
               and two sets of lines on one element was part of the footer stutter.

   TWO MEASUREMENT TRAPS ON THE MOBILE BAR:
   1. OFF-CANVAS DRAWER LINKS share the header markup and sit at negative coordinates
      while closed, so the rightmost link measured -18 and the line drew off-screen.
   2. THE LOGO LINK IS WIDER THAN THE CREST, so measuring it put the line 89px past the
      logo. The image inside is measured instead.

   THE HEADER needs retries: it is not laid out at DOMContentLoaded, and the theme
   re-renders it afterwards, which removes the SVG - so the size stamp is only trusted
   when the drawing is still present.

   PERFORMANCE. The observer watches only the submenus, never the document - drawing
   mutates the DOM, so watching everything meant every draw retriggered the observer.
   That loop was the menu lag. */

(function () {
  var IN = 5, IC = 5.07;
  var NS = 'http://www.w3.org/2000/svg';
  var PANELS = '.menu-list__submenu';
  var BUTTONS = 'a.button, button.button, .ap-guide-button, .inquiry-submit-btn, ' +
                'a[class*="ai-ap-guide-button-"]';
  var BAR = '.header__row--top';
  var FOOTER = '.custom-footer-wrapper';
  var LOGO = '.header__logo, .header__heading-link, .header__heading, .header-logo';

  var stamps = new WeakMap();
  var seen = new WeakMap();
  var drawing = false;

  function el(n, a) {
    var e = document.createElementNS(NS, n);
    for (var k in a) e.setAttribute(k, a[k]);
    return e;
  }

  function isect(a, b, c, d) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1];
    var x3 = c[0], y3 = c[1], x4 = d[0], y4 = d[1];
    var den = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (Math.abs(den) < 1e-9) return null;
    var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / den;
    return [x1 + t * (x2 - x1), y1 + t * (y2 - y1)];
  }

  function contentRight(node) {
    var r = node.getBoundingClientRect(), max = 0;
    node.querySelectorAll('a, h3, span, input, li, p, svg, summary').forEach(function (e) {
      var er = e.getBoundingClientRect();
      if (er.width < 3) return;
      var right = er.right - r.left;
      if (right > max && right <= r.width) max = right;
    });
    return max;
  }

  function stepFor(node, mode, w, inner) {
    if (mode === 'content') {
      var free = w - IN - contentRight(node) - 2;
      return Math.max(4, Math.min(16, Math.floor(free / 2)));
    }
    var tight = (mode !== 'panel');
    return Math.max(5, Math.min(16, Math.floor((inner - (tight ? 16 : 20)) / 4)));
  }

  function geometryFor(node, mode, w, rightEdge) {
    if (mode === 'button')  return { a: w * 0.35, b: w * 0.40, solid: null };
    if (mode === 'panel')   return { a: w * 0.44, b: w * 0.42, solid: null };
    if (mode === 'content') return { a: w * 0.40, b: w * 0.38, solid: null };

    var r = node.getBoundingClientRect();
    var end = null, items = [];

    node.querySelectorAll('a').forEach(function (a) {
      if (a.closest(PANELS)) return;
      if (a.closest(LOGO)) return;
      var t = (a.textContent || '').trim();
      if (t.length < 2) return;
      var ar = a.getBoundingClientRect();
      if (ar.width < 4) return;
      var right = ar.right - r.left, left = ar.left - r.left;
      if (right <= 0 || left >= w || right > w) return;
      items.push(right);
    });
    if (items.length) end = Math.max.apply(null, items);

    if (end == null) {
      var art = node.querySelector(LOGO + ' img, ' + LOGO + ' svg') ||
                node.querySelector('a img, a svg') || node.querySelector(LOGO);
      if (art) {
        var ar2 = art.getBoundingClientRect();
        var right2 = ar2.right - r.left;
        if (ar2.width > 8 && right2 > 0 && right2 < w) end = right2 + 14;
      }
    }
    if (end == null) end = w * 0.62;

    var solid = (end + rightEdge) / 2;
    return { a: end, b: Math.min(end + 18, solid), solid: solid };
  }

  function render(node, mode, w, h) {
    var inner = h - IN * 2;
    if (w < 120 || inner < 26) return;

    drawing = true;
    stamps.set(node, w + 'x' + h);
    var old = node.querySelector(':scope > .mr-facet-svg');
    if (old) old.remove();

    var tight = (mode !== 'panel');
    var STEP = stepFor(node, mode, w, inner);
    if (getComputedStyle(node).position === 'static') node.style.position = 'relative';

    var uid = 'mrf' + Math.random().toString(36).slice(2, 8), n = 0;
    var svg = el('svg', {
      'class': 'mr-facet-svg', width: w, height: h, viewBox: '0 0 ' + w + ' ' + h,
      'aria-hidden': 'true',
      style: 'position:absolute;left:0;top:0;pointer-events:none;z-index:1;overflow:hidden'
    });
    var defs = el('defs', {});
    svg.appendChild(defs);

    var R2x = w - IN - STEP, R1x = w - IN - STEP * 2;
    var st = geometryFor(node, mode, w, R1x);
    var R2 = { x: R2x, top: IN + STEP,     bot: h - IN - STEP,     o: 0.62, s: st.b };
    var R1 = { x: R1x, top: IN + STEP * 2, bot: h - IN - STEP * 2, o: 0.95, s: st.a };

    var dTA = [[R1.x, R1.top], [w - IN - IC, IN]];
    var dTB = [[R1.x, R1.top], [w - IN, IN + IC]];
    var dBA = [[R1.x, R1.bot], [w - IN - IC, h - IN]];
    var dBB = [[R1.x, R1.bot], [w - IN, h - IN - IC]];

    function fade(ax, ay, bx, by, op) {
      var id = uid + (n++);
      var g = el('linearGradient', { id: id, gradientUnits: 'userSpaceOnUse', x1: ax, y1: ay, x2: bx, y2: by });
      g.appendChild(el('stop', { offset: '0', 'stop-color': '#fff', 'stop-opacity': '0' }));
      if (st.solid != null && bx !== ax) {
        var f = (st.solid - ax) / (bx - ax);
        f = Math.max(0.05, Math.min(0.95, f));
        g.appendChild(el('stop', { offset: (f * 0.5).toFixed(3), 'stop-color': '#fff', 'stop-opacity': (op * 0.3).toFixed(2) }));
        g.appendChild(el('stop', { offset: f.toFixed(3), 'stop-color': '#fff', 'stop-opacity': op }));
      } else {
        g.appendChild(el('stop', { offset: tight ? '0.5' : '0.55', 'stop-color': '#fff',
                                   'stop-opacity': (op * (tight ? 0.32 : 0.5)).toFixed(2) }));
      }
      g.appendChild(el('stop', { offset: '1', 'stop-color': '#fff', 'stop-opacity': op }));
      defs.appendChild(g);
      return 'url(#' + id + ')';
    }

    svg.appendChild(el('line', { x1: R1.x, y1: R1.top, x2: R1.x, y2: R1.bot, stroke: '#fff', 'stroke-width': 1, 'stroke-opacity': R1.o }));
    svg.appendChild(el('line', { x1: R1.s, y1: R1.top, x2: R1.x, y2: R1.top, stroke: fade(R1.s, R1.top, R1.x, R1.top, R1.o), 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: R1.s, y1: R1.bot, x2: R1.x, y2: R1.bot, stroke: fade(R1.s, R1.bot, R1.x, R1.bot, R1.o), 'stroke-width': 1 }));

    var cTop = isect([R2.s, R2.top], [R2.x, R2.top], dTA[0], dTA[1]) || [R2.x, R2.top];
    var cBot = isect([R2.s, R2.bot], [R2.x, R2.bot], dBA[0], dBA[1]) || [R2.x, R2.bot];
    var vTop = isect([R2.x, R2.top], [R2.x, R2.bot], dTB[0], dTB[1]) || [R2.x, R2.top];
    var vBot = isect([R2.x, R2.top], [R2.x, R2.bot], dBB[0], dBB[1]) || [R2.x, R2.bot];

    svg.appendChild(el('line', { x1: R2.s, y1: R2.top, x2: cTop[0], y2: cTop[1], stroke: fade(R2.s, R2.top, cTop[0], cTop[1], R2.o), 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: R2.s, y1: R2.bot, x2: cBot[0], y2: cBot[1], stroke: fade(R2.s, R2.bot, cBot[0], cBot[1], R2.o), 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: R2.x, y1: vTop[1], x2: R2.x, y2: vBot[1], stroke: '#fff', 'stroke-width': 1, 'stroke-opacity': R2.o }));

    [dTA, dTB, dBA, dBB].forEach(function (d) {
      svg.appendChild(el('line', { x1: d[0][0], y1: d[0][1], x2: d[1][0], y2: d[1][1], stroke: '#fff', 'stroke-width': 1, 'stroke-opacity': 0.9 }));
    });

    node.insertBefore(svg, node.firstChild);
    drawing = false;
  }

  /* Force a hidden panel measurable for one synchronous moment, draw into it, and put
     its inline style back exactly as it was. Nothing paints in between. */
  function prime(node, mode) {
    if (node.querySelector(':scope > .mr-facet-svg')) return;
    var saved = node.getAttribute('style') || '';
    node.style.cssText = saved +
      ';display:block !important;visibility:hidden !important;opacity:0 !important;' +
      'position:absolute !important;pointer-events:none !important;' +
      'transition:none !important;animation:none !important;';
    var w = Math.round(node.offsetWidth), h = Math.round(node.offsetHeight);
    if (w && h) render(node, mode, w, h);
    if (saved) node.setAttribute('style', saved); else node.removeAttribute('style');
  }

  function visible(p) {
    var cs = getComputedStyle(p);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    if (parseFloat(cs.opacity) < 0.02) return false;
    if (!p.offsetWidth || !p.offsetHeight) return false;
    return true;
  }

  function draw(node, mode) {
    if (!visible(node)) return;
    var w = Math.round(node.offsetWidth), h = Math.round(node.offsetHeight);
    if (!w || !h) return;
    var size = w + 'x' + h;
    var existing = node.querySelector(':scope > .mr-facet-svg');
    if (existing && stamps.get(node) === size) return;
    if (seen.get(node) !== size) {
      seen.set(node, size);
      window.requestAnimationFrame(function () { draw(node, mode); });
      return;
    }
    render(node, mode, w, h);
  }

  function isDesktop() { return window.innerWidth >= 900; }

  function primePanels() { if (!isDesktop()) return;
                           document.querySelectorAll(PANELS).forEach(function (p) { prime(p, 'panel'); }); }
  function runPanels()   { if (!isDesktop()) return;
                           document.querySelectorAll(PANELS).forEach(function (p) { draw(p, 'panel'); }); }
  function runButtons()  { document.querySelectorAll(BUTTONS).forEach(function (b) { draw(b, 'button'); }); }
  function runBar()      { document.querySelectorAll(BAR).forEach(function (b) { draw(b, 'bar'); }); }
  function runFooter()   { if (window.innerWidth < 768) return;
                           document.querySelectorAll(FOOTER).forEach(function (f) { draw(f, 'content'); }); }
  function runStatic()   { runBar(); runButtons(); runFooter(); }

  function watch() {
    primePanels();
    runStatic();

    window.addEventListener('load', function () { primePanels(); runStatic(); });
    [200, 700, 1800, 3500].forEach(function (ms) { setTimeout(function () { primePanels(); runStatic(); }, ms); });

    document.querySelectorAll(BAR).forEach(function (bar) {
      new MutationObserver(function () {
        if (drawing) return;
        window.requestAnimationFrame(runBar);
      }).observe(bar, { childList: true });
    });

    // safety net only: a panel that changes size after it was primed
    var mo = new MutationObserver(function (records) {
      if (drawing) return;
      var hit = false;
      records.forEach(function (r) { if (r.target && r.target.matches && r.target.matches(PANELS)) hit = true; });
      if (hit) window.requestAnimationFrame(runPanels);
    });
    document.querySelectorAll(PANELS).forEach(function (p) {
      mo.observe(p, { attributes: true, attributeFilter: ['style', 'class', 'aria-expanded', 'open'] });
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll('.mr-facet-svg').forEach(function (s) {
          stamps.delete(s.parentNode);
          seen.delete(s.parentNode);
          s.remove();
        });
        primePanels(); runStatic();
      }, 200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
